<template>
  <div class="flow-detail">
    <div class="header">
      <h1 class="title">提成发放规则申报</h1>
      <div class="operate">
        <Button
          type="primary"
          @click="back"
        >返回列表</Button>
      </div>
      <div class="create-info">
        <div
          class="info-item"
          style="width:100%;"
        >
          <span class="title">流程名称：</span>
          <span>{{flowItemDetail.WorkflowTitle}}</span>
        </div>
        <div
          class="info-item"
          style="width:100%;"
        >
          <span class="title">流程Id：</span>
          <span>{{flowItemDetail.SheetId}}</span>
        </div>
        <div class="info-item">
          <span class="title">申报人：</span>
          <span>{{flowItemDetail.CreatorRealName}}</span>
        </div>
        <div class="info-item">
          <span class="title">创建时间：</span>
          <span>{{flowItemDetail.CreatedTime | filterTime}}</span>
        </div>
        <div class="info-item">
          <span class="title">部门：</span>
          <span>{{flowExtraInfo.area}}</span>
        </div>
        <div class="info-item">
          <span class="title">分子公司：</span>
          <span>{{flowExtraInfo.company}}</span>
        </div>
        <div class="status">
          <div>状态</div>
          <div
            class="status-text"
            :style="{color: flowDetailStatus.color}"
          >{{flowDetailStatus.title}}</div>
        </div>
        <div class="examine-btn">
          <Button
            type="success"
            style="margin-right:5px;"
            :disabled="flowDetailStatus.title === '成功' || user.name !== flowDetailHistory[flowDetailHistory.length-1].RealName"
            @click="approvalFlowNext"
          >通过/转交</Button>
          <Button
            type="error"
            :disabled="flowDetailStatus.title === '驳回' || flowDetailStatus.title === '成功' || user.name !== flowDetailHistory[flowDetailHistory.length-1].RealName"
            @click="rejectFlow"
          >退回</Button>
        </div>
      </div>
      <Tabs>
        <TabPane label="详情"></TabPane>
      </Tabs>
    </div>
    <div
      class="extra-info"
      style="margin-top:10px;"
    >
      <div v-if="flowType === 'GZ'">
        <commissionRuleExtra :flowDetail="flowExtraInfo"></commissionRuleExtra>
      </div>
      <div v-if="flowType === 'QR'">
        <commissionDeclareExtra :flowDetail="flowExtraInfo" :flowLine="flowLine"></commissionDeclareExtra>
      </div>
      <div v-if="flowType === 'FP'">
        <commissionGrantExtra :flowDetail="flowExtraInfo"></commissionGrantExtra>
      </div>
      <div v-if="flowType === 'RM'">
        <depositExamineExtra
          :flowDetail="flowExtraInfo"
          :flowInstance="flowItemDetail"
        ></depositExamineExtra>
      </div>
    </div>
    <Card
      style="margin-top: 10px;"
      :bordered="false"
    >
      <p slot="title">流程详情</p>
      <Table
        :columns="historyColumns"
        :data="flowDetailHistory"
      ></Table>
    </Card>
    <Card
      style="margin-top: 10px;"
      :bordered="false"
    >
      <p slot="title">说明</p>
      <div>
        <span></span>
      </div>
    </Card>
    <!-- 流程人员选择 -->
    <Modal
      v-model="flowNextVisible"
      class="flow-modal"
      width="700px"
      title="流程人员选择"
    >
      <flowNext
        :child-msg="flowPeople"
        @toparentevent="handleFlowNext"
      ></flowNext>
      <div slot="footer">
        <Button @click="flowNextVisible=false">取消</Button>
        <Button
          @click="nextFlow"
          type="primary"
        >确定</Button>
      </div>
    </Modal>
    <!-- 流程分支 -->
    <flowBranch
      :visible="branchVisible"
      :branchList="flowBranch"
      @visibleChange="visibleChange"
      @branchChoose="branchChoose"
      :branchType="branchType"
    ></flowBranch>
    <!-- 退回意见 -->
    <Modal
      v-model="rejectOpinionVisible"
      title="退回原因"
    >
      <Input v-model="rejectOpinion"></Input>
      <div slot="footer">
        <Button @click="rejectOpinionVisible=false">取消</Button>
        <Button
          type="primary"
          @click="rejectFlowConfirm"
        >确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { formatDate } from '@/lib/tool'
import { getFlowHistory, approvalFlow, getActivityUsers, deliverFlow, endFlow, getRejectActivityUsers, rejectFlow } from '@/lib/flow'
import FlowBranch from './flowBranch'
import FlowNext from "./flowNext"
import CommissionRuleExtra from './extraInfo/commissionRuleExtra'
import CommissionDeclareExtra from './extraInfo/commissionDeclareExtra'
import CommissionGrantExtra from './extraInfo/commissionGrantExtra'
import DepositExamineExtra from './extraInfo/depositExamineExtra'
import axios from 'axios'

export default {
  name: 'flowDetail',
  components: {
    FlowBranch,
    FlowNext,
    CommissionRuleExtra,
    CommissionDeclareExtra,
    CommissionGrantExtra,
    DepositExamineExtra,
  },
  props: {
    flowItemDetail: {
      type: Object,
    },
    flowType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      flowExtraInfo: '',
      flowDetailHistory: [],
      flowDetailStatus: '未知',
      historyColumns: [
        {
          title: '操作类型',
          key: 'ActivityShowName'
        },
        {
          title: '操作人',
          key: 'RealName',
        },
        {
          title: '执行结果',
          render: (h, params) => {
            let result = '-'
            let resultColor = ''
            switch (params.row.CompletedType) {
              case 'StartWorkflow':
                resultColor = '#19be6b'
                result = '发起'
                break
              case 'Approval':
                resultColor = '#19be6b'
                result = '通过'
                break
              case 'Reject':
                resultColor = '#ed3f14'
                result = '驳回'
                break
              case '':
                resultColor = '#ff9900'
                result = '待办'
                break
            }
            let style = {
              backgroundColor: resultColor,
              borderRadius: '50%',
              width: '6px',
              height: '6px',
              display: 'inline-block',
              marginRight: '5px'
            }
            return (
              <div>
                <div style={style}></div>
                <span>{result}</span>
              </div>
            )
          }
        },
        {
          title: '操作时间',
          render: (h, params) => {
            let time = ''
            if (params.row.CompletedTime) {
              time = parseInt(params.row.CompletedTime.slice(6, 19))
              time = formatDate(time).split(' ')[0]
            }
            return h('div', time)
          }
        },
        {
          title: '备注',
          key: 'Opinion'
        }
      ],
      branchVisible: false,
      flowBranch: [],
      flowPeople: {},
      flowNextVisible: false,
      nextFlowDetail: {},
      branchType: 'next',
      rejectOpinionVisible: false,
      rejectOpinion: '',
      user: {
        name: ''
      },
      flowLine: ''
    }
  },
  methods: {
    async approvalFlowNext() {
      this.$Spin.show()
      // 获取流程人员
      try {
        let rep = await getActivityUsers({ appId: this.flowType, userPhone: this.$store.state.session.user.phoneNumber, taskId: this.flowItemDetail.TaskId })
        this.$Spin.hide()
        this.branchType = 'next'
        this.flowBranch = rep
        this.branchVisible = true
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('流程人员获取失败')
      }
    },
    visibleChange(val) {
      this.branchVisible = val
    },
    branchChoose(val) {
      this.branchVisible = false
      this.flowPeople = val
      if (this.branchType === 'next') {
        // 下一流程人员选择
        this.flowNextVisible = true
      }
      if (this.branchType === 'reject') {
        // 退回意见输入
        this.rejectOpinion = ''
        this.rejectOpinionVisible = true
      }
    },
    handleFlowNext(nextFlow) {
      this.nextFlowDetail = nextFlow
    },
    async nextFlow() {
      this.$Spin.show()
      this.branchType = 'next'
      if (this.flowPeople.NextActivityName !== '结束') {
        // 流程转交
        try {
          let processVariablesJson = JSON.stringify([{ key: 'district', value: this.flowExtraInfo.area }])
          let rep = await deliverFlow(this.$store.state.session.user.phoneNumber, { taskId: this.flowItemDetail.TaskId, nextActivityCode: this.flowPeople.NextActivityCode, userId: this.nextFlowDetail.userId, processVariablesJson: processVariablesJson })
          this.$Spin.hide()
          this.$Message.success('流程流转到下一步')
          this.flowNextVisible = false
          // 返回列表页
          this.back()
        } catch (err) {
          console.error(err)
          this.$Spin.hide()
          this.$Message.error('流程转交失败')
        }
      } else {
        // 结束流程
        try {
          let rep = await endFlow(this.$store.state.session.user.phoneNumber, { taskId: this.flowItemDetail.TaskId, nextActivityCode: this.flowPeople.NextActivityCode })
          this.$Spin.hide()
          this.$Message.success('流程结束成功')
          this.flowNextVisible = false
          // 流程结束，修改状态
          if (this.flowType === 'FP' && this.flowLine.indexOf('线下') !== -1) {
            let date = new Date(this.flowExtraInfo.time)
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            month = ('0' + month).substr(-2, 2)
            date = `${year}-${month}-01`
            // 不经此处流转
            // axios.get('http://oa.chinapsp.cn:8088/NeiWebApi/CaiLian/MBonus', {
            //   params: {
            //     department: this.flowExtraInfo.area,
            //     verify: '1',
            //     date: date
            //   }
            // })
          }
          if (this.flowType === 'FP' && this.flowLine.indexOf('线上') !== -1) {
            let date = new Date(this.flowExtraInfo.time)
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            month = ('0' + month).substr(-2, 2)
            date = `${year}-${month}-01`
            // axios.post(`http://www.choicelink.cn:8888/AgentApi/Orders/UpCwProjects?cwarea=${this.flowExtraInfo.area}&cwmonth=${date}`)
            axios.post(`http://medical.chinapsp.cn:8888/AgentApi/Orders/UpCwProjects?cwarea=${this.flowExtraInfo.area}&cwmonth=${date}`)
          }
          // 返回列表页
          this.back()
        } catch (err) {
          console.error(err)
          this.$Spin.hide()
          this.$Message.error('流程结束失败')
        }
      }
    },
    async rejectFlow() {
      // 获取流程人员
      this.$Spin.show()
      try {
        let rep = await getRejectActivityUsers(this.$store.state.session.user.phoneNumber, this.flowItemDetail.TaskId)
        this.$Spin.hide()
        this.branchType = 'reject'
        this.flowBranch = rep
        this.branchVisible = true
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('退回流程获取失败')
      }
    },
    async rejectFlowConfirm() {
      if (this.rejectOpinion === '') {
        this.$Message.info('请输入退回原因或意见')
        return
      }
      this.$Spin.show()
      try {
        let rep = await rejectFlow(this.$store.state.session.user.phoneNumber, { taskId: this.flowItemDetail.TaskId, activityCode: this.flowPeople.ActivityCode, opinion: this.rejectOpinion })
        this.$Spin.hide()
        this.$Message.success('退回操作成功')
        this.rejectOpinionVisible = false
        // 返回列表页
        this.back()
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('退回操作失败')
      }
    },
    back() {
      this.$emit('back')
    }
  },
  watch: {
    flowItemDetail: {
      async handler(val) {
        if (Object.keys(val).length !== 0) {
          this.flowExtraInfo = JSON.parse(val.BusinessKey)

          this.flowLine = this.flowExtraInfo.flowLine ? this.flowExtraInfo.flowLine : '线下'

          this.flowDetailStatus = {
            title: '未知',
            color: '#000'
          }

          switch (val.WorkflowInstanceState) {
            case 3:
              this.flowDetailStatus = {
                title: '成功',
                color: '#19be6b'
              }
              break
            case 5:
              this.flowDetailStatus = {
                title: '驳回',
                color: '#ed3f14'
              }
              break
            case 2:
              this.flowDetailStatus = {
                title: '待办',
                color: '#ff9900'
              }
              break
          }
          // 获取流程详情
          try {
            this.user = this.$store.state.session.user
            let rep = await getFlowHistory(this.$store.state.session.user.phoneNumber, val.WorkflowInstanceId)
            this.flowDetailHistory = rep
          } catch (err) {
            console.error(err)
            this.flowDetailHistory = []
          }

        }
      },
      immediate: true
    },
  },
  filters: {
    filterTime(val) {
      if (!val) {
        return ''
      }
      let time = parseInt(val.slice(6, 19))
      time = formatDate(time).split(' ')[0]
      return time
    }
  }
}
</script>

<style lang="less">
.flow-detail {
  .header {
    position: relative;
    width: 100%;
    background: #fff;
    padding: 10px 26px 0 26px;
    .title {
      font-size: 20px;
      margin-bottom: 16px;
    }
    .operate {
      position: absolute;
      top: 10px;
      right: 16px;
    }
    .create-info {
      width: 90%;
      max-width: 700px;
      padding: 10px 30px;
      .info-item {
        width: 50%;
        line-height: 20px;
        max-width: 350px;
        display: inline-block;
        vertical-align: top;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        padding-bottom: 8px;
        .title {
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
        }
      }
    }
    .status {
      position: absolute;
      top: 70px;
      right: 180px;
      color: rgba(0, 0, 0, 0.45);
      font-size: 14px;
      text-align: right;
      .status-text {
        color: rgba(0, 0, 0, 0.85);
        font-size: 20px;
      }
    }
    .examine-btn {
      position: absolute;
      top: 83px;
      right: 16px;
    }
  }
}
.ivu-tabs-bar {
  margin-bottom: 0;
}
</style>
